import {fetch} from "utils/dataAccess";

export async function getStockAlerts(startDate, endDate, retailer = null) {
    let url = `/dashboard/stock_alerts?startDate=${startDate}&endDate=${endDate}`;

    if (retailer) {
        url += `&retailer=${String(retailer).replace('/retailers/', '')}`;
    }

    const response = await fetch(url);

    return response.json();
}
